<template>
  <div>
    <Modal
      :show="inviteModal"
      :disable-action="() => (inviteModal = false)"
      :content="{
        title: `Olá ${inviteData.firstName}, você foi convidado a participar do time ${inviteData.teamName}`,
        text: 'Faça login para aceitar o pedido e entrar no time'
      }"
      :buttons="{
        primary: 'Ok, Fechar!'
      }"
      @primary-button-clicked="inviteModal = false"
    />
  </div>
</template>
<script setup lang="ts">
import { InviteData } from "@/@types/invite";
import { ref } from "vue";
import Modal from "../../components/core/modal/ModalCore.vue";

interface Props {
  inviteData: InviteData;
}

const props = defineProps<Props>();
props;

const inviteModal = ref(true);
</script>
<style lang="scss" scoped>
@use "../../assets/sass/core/mixins" as *;

.team-invite__container {
  height: 100vh;
  @include flex-center(column);
}

main.team-invite__main {
  width: 100%;
  max-width: 450px;
  @include flex-center(column);
  gap: 20px;

  & > * {
    text-align: center;
  }

  h2 {
    color: #41167f;
    margin-bottom: 0px;
    padding-inline: 20px;
    font-size: 21px;
  }

  p {
    margin-bottom: 0px;
    font-size: 15px;
  }

  button {
    background: #41167f;
    border-radius: 5px;
    color: white;
    font-weight: bold;
    height: 55px;
    width: 100%;
    border: none;
    font-size: 18px;
    margin-top: 10px;
    width: 100%;
    max-width: 250px;
    transition: 0.2s ease-in-out;
    &.outlined {
      background: transparent;
      border: 2px solid #41167f;
      color: #41167f;
    }
    &[disabled] {
      background: rgb(176, 157, 199);
    }

    &:hover {
      background: rgb(243, 243, 243);
    }
  }
}
</style>
